import {useEffect} from 'react';

import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';

import {Typography} from '@mui/material';

import {EmpionPaper} from '../../../../../../../components/EmpionPaper/EmpionPaper';
import {empionGreen} from '../../../../../../../layouts/theme/EmpionColors';

export const ThankYouPage = () => {
  const {t} = useTranslation();
  const navigate = useNavigate();

  useEffect(() => {
    setTimeout(() => {
      navigate('/');
    }, 5000);
    //eslint-disable-next-line
  }, []);

  return (
    <EmpionPaper
      sx={{
        backgroundColor: '#F5F5F5',
        padding: '3rem',
        marginTop: '10rem',
      }}
    >
      <Typography
        variant='h1'
        gutterBottom
        align='center'
        sx={{
          color: empionGreen[700],
        }}
      >
        {t('companySurveys.public.thankYou.title')}
      </Typography>
    </EmpionPaper>
  );
};
